// delete with removal of contentTypeMenuUpdate FF
import { GenericMenuItemInfo } from '@tableau/widgets';
import { bindActionCreators } from 'redux';
import _ from 'underscore';

import { selectFlowsOnSiteEnabled } from '../../../flow/selectors/FlowSelectors';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCountsUpToDate } from '../../selectors/ContentCountsSelector';
import { selectEffectiveProjectSpaceContentTypes   } from '../../selectors/ContentFilterSelectors';
import { AppState } from '../../state/AppState';
import { ISpaceInfoTypeItemCount, SpaceInfoTypeContentCounts } from '../../state/ContentCountsState';
import { MapDispatchToProps } from '../../utils/ConnectUtils';
import { ExplorerDropdownItemFormatter } from './ExplorerDropdownPanelItems';
import {
  ExplorerListMenuPanelDispatchProps,
  ExplorerListMenuPanelStateProps
} from './ExplorerListMenuPanel';
import { MixedContentItemDefinition } from '../../../contentDefinitionInterfaces/ContentDefinitionsTypes';

export namespace ConnectedFilterByTypeMenuHelpers {

  const isChecked = (value: string, currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>) => {
    return _.some(currentTypeFilters, (selectedItem) => {
      if (selectedItem === 'dataconnection') {
        return value === 'datasource';
      }
      return selectedItem === value;
    });
  };

  export const mapToMenuItems = (
    contentDefinitions: MixedContentItemDefinition[],
    currentTypeFilters: ReadonlyArray<ExploreContentApi_ContentType>,
    contentCounts: ISpaceInfoTypeItemCount<'project'>,
    contentCountsUpToDate: boolean,
  ): GenericMenuItemInfo[] => {
    return _.compact(contentDefinitions
      .map((contentDefinition: MixedContentItemDefinition) => {
        return {
          value: contentDefinition.itemType,
          disabled: false,
          checked: isChecked(contentDefinition.itemType, currentTypeFilters),
          displayFormatterBoundWithData: ExplorerDropdownItemFormatter(contentDefinition.pluralName(),
                                                                      contentCountsUpToDate && contentCounts && contentCounts[contentDefinition.itemType],
                                                                      contentCountsUpToDate),
          keyboardAccessibleValue: contentDefinition.pluralName()
        } as GenericMenuItemInfo;
      }));
  };

  export const mapStateToProps = (
    state: AppState,
    contentCounts: SpaceInfoTypeContentCounts,
    getMenuItems: (
      currentTypeFilters: ReadonlyArray<ExplorableItemType>,
      contentCounts: SpaceInfoTypeContentCounts,
      contentCountsUpToDate: boolean,
      showWorkbooksAsViews: boolean,
      flowsEnabled: boolean) => GenericMenuItemInfo[]
  ): ExplorerListMenuPanelStateProps => {
    const contentCountsUpToDate = selectContentCountsUpToDate(state);
    const currentTypeFilters = selectEffectiveProjectSpaceContentTypes(state);
    const showWorkbooksAsViews = state.contentExplorer.showWorkbooksAsViews;
    const flowsEnabled = selectFlowsOnSiteEnabled(state);
    const menuItems = getMenuItems(
      currentTypeFilters,
      contentCounts,
      contentCountsUpToDate && contentCounts != null,
      showWorkbooksAsViews,
      flowsEnabled
    );
    return {
      menuItems
    };
  };

  export const mapDispatchToProps: MapDispatchToProps<ExplorerListMenuPanelDispatchProps> =
    (dispatch) => bindActionCreators({
      onComponentDidUpdate: contentCountsRequest
    },
    dispatch);

}
